import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { mapRepliconDateToUtcObject } from '~/modules/common/dates/convert';
import {
  getTotalHoursForDateRangeFromScheduleRules,
  roundToDecimals
} from '~/modules/resourcing/common/util/scheduleUtil';
import TooltipLayout from '../../common/components/TooltipLayout';

const EditorPopoverTooltip = ({
  endDate,
  otherTaskAllocationsSummaryScheduleRules,
  projectAvailableHours,
  resourceAllocationScheduleRules,
  startDate
}) => {
  const startDateUtc = mapRepliconDateToUtcObject(startDate);
  const endDateUtc = mapRepliconDateToUtcObject(endDate);

  const otherTaskAllocatedHours =
    otherTaskAllocationsSummaryScheduleRules &&
    getTotalHoursForDateRangeFromScheduleRules({
      start: startDateUtc,
      end: endDateUtc,
      scheduleRules: otherTaskAllocationsSummaryScheduleRules
    });
  const resourceAllocatedHours = getTotalHoursForDateRangeFromScheduleRules({
    start: startDateUtc,
    end: endDateUtc,
    scheduleRules: resourceAllocationScheduleRules
  });

  const calculationRows = useMemo(
    () => [
      {
        messageId: 'taskAllocationEditor.projectAllocation',
        value: roundToDecimals(resourceAllocatedHours)
      },
      {
        messageId: 'taskAllocationEditor.allocatedToOtherTask',
        value: roundToDecimals(otherTaskAllocatedHours || 0)
      }
    ],
    [otherTaskAllocatedHours, resourceAllocatedHours]
  );

  const resultRow = useMemo(
    () => [
      {
        messageId: 'taskAllocationEditor.availableAllocation',
        value: roundToDecimals(projectAvailableHours)
      }
    ],
    [projectAvailableHours]
  );

  return (
    <TooltipLayout
      calculationRows={calculationRows}
      resultRow={resultRow}
      startDate={startDateUtc}
      endDate={endDateUtc}
    />
  );
};

EditorPopoverTooltip.propTypes = {
  endDate: PropTypes.object,
  otherTaskAllocationsSummaryScheduleRules: PropTypes.array,
  projectAvailableHours: PropTypes.number,
  resourceAllocationScheduleRules: PropTypes.array,
  startDate: PropTypes.object
};

export default EditorPopoverTooltip;
